export default "__VITE_ASSET__575b6b3e__"